import React from "react";
export default function Tick() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "tick",
    fillRule: "nonzero",
    stroke: "white",
    strokeWidth: "2.1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.25 8.25L6 11l6.75-6.75"
  }))));
}